import React, { useContext } from 'react';
import classNames from 'classnames';
import { DirectionalHint } from '@fluentui/react';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { customUserGovernanceConfig } from './coupon-user-governance-config';
import { useStyles } from './styles/styles';

export const CouponTeachingBubbleStepOne = () => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);

  return (
    <div className={classNames(styles.container)}>
      <div className={classNames(styles.imagecontainer)}>
        <Glyphicon glyph="ba-Lightbulb" className={classNames(styles.couponlightbulb)} />
        {i18n.getString(_TL_('Redeem your feature adoption coupon'))}
      </div>
      <div className={classNames(styles.couponimagecontainer)}>
        <div className={classNames(styles.couponimage)} />
      </div>
      <div className={classNames(styles.couponsubtitle)}>
        {i18n.getString(_TL_('You have a new coupon offer!'))}
      </div>
      <div>
        {i18n.getString(_TL_('To access your coupon, select Billing and then select the coupon from the grid.'))}
      </div>
    </div>
  );
};

export const couponTeachingBubbleConfig =
{
  featureName: 'coupon-teaching-bubble',
  userGovernanceConfig: customUserGovernanceConfig,
  isLightDismissSupported: true,
  steps: [
    {
      title: '',
      content: (<CouponTeachingBubbleStepOne />),
      primaryButtonText: _TL_('Go to coupons'),
      secondaryButtonText: _TL_('Got it'),
      // #billing is different in CCUI and CampaignUI, need to fix in primary navigation
      targetElement: 'div#billing>button.side-navigation-item-button,button#billing.side-navigation-item-button',
      directionalHint: DirectionalHint.rightCenter,
      onNext: (scope, siteMap) => {
        scope.save(getRoutePathById(siteMap, 'coupon'));
      },
      hideAnnotation: true,
    },
    {
      title: _TL_('Redeem your feature adoption coupon'),
      content: _TL_('To redeem your coupon, select the coupon link in the Status column. Next, make sure you’ve met the feature adoption requirements outlined in the following steps.'),
      primaryButtonText: _TL_('Got it'),
      isSecondaryButtonHidden: true,
      targetElement: 'div[data-coupon-status="coupon-status"]',
      directionalHint: DirectionalHint.rightCenter,
      hideAnnotation: true,
    },
  ],
};

export const couponTeachingBubbleOldUIConfig =
{
  featureName: 'coupon-teaching-bubble-oldui',
  userGovernanceConfig: customUserGovernanceConfig,
  isLightDismissSupported: true,
  steps: [
    {
      title: _TL_('Coupon is available'),
      content: _TL_('You have a new coupon offer! To access your coupon, select Billing and then select the coupon from the grid.'),
      primaryButtonText: _TL_('Go to coupon page'),
      secondaryButtonText: _TL_('Got it'),
      targetElement: 'button#tools.global-menu-tools-dropdown-toggle',
      directionalHint: DirectionalHint.bottomRightEdge,
      onNext: (scope, siteMap) => {
        scope.save(getRoutePathById(siteMap, 'coupon'));
      },
    },
    {
      title: _TL_('Redeem your feature adoption coupon'),
      content: _TL_('To redeem your coupon, select the coupon link in the Status column. Next, make sure you’ve met the feature adoption requirements outlined in the following steps.'),
      primaryButtonText: _TL_('Got it'),
      isSecondaryButtonHidden: true,
      targetElement: 'div[data-coupon-status="coupon-status"]',
      directionalHint: DirectionalHint.rightCenter,
    },
  ],
};
